import { set } from "lodash"
import moment from "moment"
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react"
import Loader from "react-loaders"
import { Input } from "reactstrap"
import api from "services/api.service"
import { userService } from "services/user.service"
import colors from "utils/colors"
import isNullOrEmpty from "utils/isNullOrEmpty"

const ActualResourceGroupsTableInner = (
  { scope, itemId, scenarioId, show },
  ref
) => {
  const currentUser = userService.getLoggedInUser()
  const [actualResourceGroups, setActualResourceGroups] = useState([])
  const [resourceGroups, setResourceGroups] = useState([])
  const [users, setUsers] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useImperativeHandle(ref, () => ({
    isValid() {
      return !show || (
        actualResourceGroups.find(x => x.resourceGroupID < 0 && !x.isDeleted) ==
        undefined
      )
    },
    async save(taskId) {
      if (show &&
        actualResourceGroups.find(x => x.resourceGroupID < 0 && !x.isDeleted) ==
        undefined
      ) {
        let tasks = []
        let rgToCreate = actualResourceGroups.filter(
          x => x.resourceGroupActualID < 0
        )
        if (rgToCreate.length > 0) {
          tasks = [
            ...tasks,
            ...rgToCreate.map(x => async () => {
              return await api.createResourceGroupActual({
                ...x,
                itemID: taskId,
              })
            }),
          ]
        }

        let rgToUpdate = actualResourceGroups.filter(
          x => x.resourceGroupActualID > 0 && x.isDirty
        )
        if (rgToUpdate.length > 0) {
          tasks = [
            ...tasks,
            ...rgToUpdate.map(x => async () => {
              return await api.updateResourceGroupActual({
                ...x,
                itemID: taskId,
              })
            }),
          ]
        }

        let rgToDelete = actualResourceGroups.filter(x => x.isDeleted)
        if (rgToDelete.length > 0) {
          tasks = [
            ...tasks,
            ...rgToDelete.map(x => async () => {
              return await api.deleteResourceGroupActual(
                x.resourceGroupActualID
              )
            }),
          ]
        }

        if (tasks.length > 0) {
          console.log(tasks)
          await Promise.all(tasks.map(t => t()))
        }
      }
    },
  }))

  useEffect(() => {
    if (show) loadData()
  }, [scenarioId, show])

  const loadData = async () => {
    setIsLoading(true)
    if (!isNullOrEmpty(scope) && !isNullOrEmpty(itemId)) {
      let data = await api.getResourceGroupActuals(scope, itemId)
      setActualResourceGroups(data)
    }
    if (!isNullOrEmpty(scenarioId)) {
      let rg = await api.getResourceGroups(scenarioId, 0)
      setResourceGroups(rg)

      let s = await api.getScenario(scenarioId)
      if (!isNullOrEmpty(s)) {
        let u = await api.getUsersByEnterprise(s.enterpriseID)
        setUsers(u)
      }
    }

    setIsLoading(false)
  }

  const add = async () => {
    let id = -1
    let ids = actualResourceGroups.map(x => x.resourceGroupActualID)
    if (ids.length > 0) {
      let min = Math.min(...ids)
      if (min < 0) {
        id = min - 1
      }
    }
    let newActualResourceGroup = {
      resourceGroupActualID: id,
      resourceGroupID: -1, // to be filled on save
      userID: 0,
      startDate: moment(new Date()).format("YYYY-MM-DD"),
      endDate: moment(new Date()).format("YYYY-MM-DD"),
      numUnits: 0,
      scope: scope,
      itemId: itemId,
    }
    setActualResourceGroups([...actualResourceGroups, newActualResourceGroup])
  }

  const remove = resourceGroupActualID => {
    let copy = [...actualResourceGroups]
    let item = copy.find(x => x.resourceGroupActualID === resourceGroupActualID)
    if (item !== undefined && item !== null) {
      item.isDeleted = true
      setActualResourceGroups(copy)
    }
  }

  const changeActualResourceGroupProp = (argToChange, prop, value) => {
    let newActualResourceGroups = [...actualResourceGroups]
    let arg = newActualResourceGroups.find(
      x => x.resourceGroupActualID === argToChange.resourceGroupActualID
    )
    if (arg !== undefined && arg !== null) {
      arg[prop] = value
      arg.isDirty = true
      setActualResourceGroups(newActualResourceGroups)
    }
  }
  if (!show) {
    return null
  }
  return (
    <React.Fragment>
      {isLoading && (
        <Loader
          type="line-scale-pulse-out"
          color={colors.primary}
          style={{ textAlign: "center" }}
        />
      )}
      {!isLoading && (
        <>
        <div  style={{ padding: "5px" }}>
          <div className="divider"></div>
          <label className="form-label">Resources Used</label>
          <table
            className="table table-bordered low-padding-table"
            style={{ backgroundColor: "white" }}
          >
            <thead>
              <tr>
                <th className="col-2">Resource Group</th>
                <th className="col-2">User (opt)</th>
                <th className="col-2">Start Date</th>
                <th className="col-2">End Date</th>
                <th className="col-2">Num Units</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {actualResourceGroups
                .filter(x => !x.isDeleted)
                .map((x, index) => (
                  <tr key={index}>
                    <td>
                      <select
                        className="form-control"
                        value={x.resourceGroupID}
                        onChange={e => {
                          changeActualResourceGroupProp(
                            x,
                            "resourceGroupID",
                            e.target.value
                          )
                        }}
                      >
                        <option value="-1">Select Resource Group</option>
                        {resourceGroups.map((rg, idx) => (
                          <option key={idx} value={rg.resourceGroupID}>
                            {rg.resourceGroupName}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <select
                        className="form-control"
                        value={x.userID}
                        onChange={e => {
                          changeActualResourceGroupProp(
                            x,
                            "userID",
                            e.target.value
                          )
                        }}
                      >
                        <option value="0">Select User</option>
                        {users.map((rg, idx) => (
                          <option key={idx} value={rg.userID}>
                            {rg.firstName} {rg.lastName}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <Input
                        type="date"
                        onChange={e => {
                          changeActualResourceGroupProp(
                            x,
                            "startDate",
                            moment(e.target.value).format("YYYY-MM-DD")
                          )
                        }}
                        value={
                          x.startDate != null &&
                          new Date(x.startDate) >
                            new Date(1900, 1, 1, 0, 0, 0, 0)
                            ? moment(x.startDate).format("YYYY-MM-DD")
                            : ""
                        }
                      />
                    </td>
                    <td>
                      <Input
                        type="date"
                        onChange={e => {
                          changeActualResourceGroupProp(
                            x,
                            "endDate",
                            moment(e.target.value).format("YYYY-MM-DD")
                          )
                        }}
                        value={
                          x.endDate != null &&
                          new Date(x.endDate) > new Date(1900, 1, 1, 0, 0, 0, 0)
                            ? moment(x.endDate).format("YYYY-MM-DD")
                            : ""
                        }
                      />
                    </td>
                    <td>
                      <Input
                        className="form-control align-end"
                        type="number"
                        value={x.numUnits}
                        onChange={e => {
                          changeActualResourceGroupProp(
                            x,
                            "numUnits",
                            e.target.value
                          )
                        }}
                      />
                    </td>
                    <td>
                      <i
                        className="fas fa-trash"
                        style={{ color: "red", cursor: "pointer" }}
                        onClick={() => remove(x.resourceGroupActualID)}
                      ></i>
                    </td>
                  </tr>
                ))}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td>
                  <b>Total Units</b>
                </td>
                <td className="align-end">
                  <b>
                    {actualResourceGroups.filter(x => !x.isDeleted).length > 0
                      ? actualResourceGroups
                          .filter(x => !x.isDeleted)
                          .reduce(
                            (acc, item) => acc + parseFloat(item.numUnits),
                            0
                          )
                      : 0}
                  </b>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <button className="btn btn-primary" onClick={add}>
            Add Resource
          </button>
          <div className="divider"></div>
          </div>
        </>
      )}
    </React.Fragment>
  )
}

const ActualResourceGroupsTable = forwardRef(ActualResourceGroupsTableInner)
export default ActualResourceGroupsTable
